import React, { memo } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Modal } from 'ljit-react-components';
import './style.styl';

const { Message } = Modal;
const PREFIX_CLASS = 'confirm-modal';
const CANCEL_BUTTON_CLASS = `${PREFIX_CLASS}__cancel-button`;
const HIDE_CANCEL_BUTTON_CLASS = `${CANCEL_BUTTON_CLASS}--hide`;
const propTypes = {
	className: PropTypes.string,
	isVisible: PropTypes.bool,
	isOkButtonDisabled: PropTypes.bool,
	width: PropTypes.number,
	title: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.node,
	]),
	message: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.node,
	]),
	onClickOk: PropTypes.func,
	onClickCancel: PropTypes.func,
	okText: PropTypes.string,
	cancelText: PropTypes.string,
	cancelButtonClassname: PropTypes.string,
	isHideCancelButton: PropTypes.bool,
	maskClosable: PropTypes.bool,
};
const defaultProps = {
	className: '',
	isVisible: false,
	onClickOk: () => {},
	onClickCancel: () => {},
	isHideCancelButton: false,
};

function ConfirmModal({
	className,
	isVisible,
	width,
	title,
	isOkButtonDisabled,
	message,
	onClickOk,
	onClickCancel,
	okText,
	cancelText,
	cancelButtonClassname,
	isHideCancelButton,
	maskClosable,
}) {
	return (
		<Message
			className={cx(PREFIX_CLASS, className)}
			visible={isVisible}
			width={width}
			title={title}
			isOkButtonDisabled={isOkButtonDisabled}
			message={message}
			onClickOk={onClickOk}
			onClickCancel={onClickCancel}
			okText={okText}
			cancelText={cancelText}
			isMaskClosable={maskClosable}
			cancelButtonClassname={cx(
				cancelButtonClassname,
				CANCEL_BUTTON_CLASS,
				isHideCancelButton ? HIDE_CANCEL_BUTTON_CLASS : '',
			)}
		/>
	);
}

ConfirmModal.propTypes = propTypes;
ConfirmModal.defaultProps = defaultProps;

export default memo(ConfirmModal);
